<template>
<div class="image-view"
  oncontextmenu="return false"
  @touchstart="listen__view__onmousedown($event, 'touch')"
  @mousedown="listen__view__onmousedown($event, 'mouse')"
  @wheel="listen__view__onwheel">
  <frame
    style="background:rgba(0, 0, 0, 0);"
    ref="frame"
    :key="1"
    :frameData="frameData"
    :left-mouse-mode="leftMouseMode"
    :style="{cursor: leftMouseMode == 'pan' ? 'grab' : 'crosshair'}"
    :draw-label-text="drawLabelText"
    :draw-predicted-text="drawPredictedText"
    @onstatechange="$emit('onframestatechange', $event)"
    @onfieldadd="listen__frame__onfieldadd"
    @onfieldremove="listen__frame__onfieldremove"
    @onfieldmove="listen__frame__onfieldmove" />
  
    
    <q-dialog v-model="state.dialogAddField.show" ref="dialogAddField" persistent @hide="listen__daf__clear">
      <q-card class="my-card">

        <q-card-section>
          <div class="row no-wrap items-center">
            <div class="col text-h6 ellipsis">
              필드 추가
            </div>
            <q-space />
            <q-icon name="label_important" :style="{color:$cornerstoneTools.toolColors.getToolColor()}" size="md" />
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-input ref="dialogAddFieldNameField" v-model="state.dialogAddFieldValue.name" label="필드 이름" :rules="[val => !!val || '필수 입력 사항입니다.']" />
          <div style="height:5px" />
          <q-select v-model="state.dialogAddFieldValue.type" :options="$store.getters.fieldTypes" label="필드 형태" :option-disable="opt => opt != '기본'" />
          <div style="height:25px" />
          <div class="column">
            <span class="text-caption text-grey">인식 언어</span>
            <div class="row">
              <q-checkbox v-for="(language, index) in $store.getters.fieldLanguages" :key="`${index}`"
                v-model="state.dialogAddFieldValue.language" :label="language" :val="language"
              />
            </div>
          </div>
          <div style="height:15px" />
          <div class="column">
            <span class="text-caption text-grey">필기 형식</span>
            <div class="row">
              <q-radio v-for="(value, index) in $store.getters.fieldWritingTypes" :key="`${index}`"
                v-model="state.dialogAddFieldValue.writingType" :val="value" :label="value"
              />
            </div>
          </div>
          <div style="height:10px" />
          <q-select v-model="state.dialogAddFieldValue.dictionary.name" :options="$store.getters.fieldDictionaries" label="사전" />
          <div style="height:20px" />
          <q-checkbox left-label v-model="state.dialogAddFieldValue.dictionary.mustPick" label="사전의 가장 유사한 단어로 교체" />
        </q-card-section>

        <q-separator />

        <q-card-actions align="right">
          <q-btn v-close-popup flat color="primary" label="취소" @click="state.dialogAddField.failCallback" />
          <q-btn flat color="primary" label="저장" @click="state.dialogAddField.successCallback" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  <q-inner-loading :showing="frameData._empty == true" style="cursor:pointer"
    @click="listen__layer__onclick"
    @dragenter="listen__layer__ondragenter"
    @dragleave="listen__layer__ondragleave"
    @dragover="listen__layer__ondragover"
    @drop="listen__layer__ondrop">
    <div v-if="state.counterDrag > 0" class="column" style="align-items:center;">
      <q-icon name="mouse" size="md" />
      <span>드롭하세요.</span>
    </div>
    <div v-else-if="state.loading == false" class="column" style="align-items:center;">
      <q-icon name="file_upload" size="md" />
      <span>마우스로 파일을 드래그하거나 여기를 클릭하여 이미지 샘플을 업로드해주세요.</span>
      <span>(작성 필드 또는 체크 박스에 입력된 값이 없는 '미기입 원본 이미지 파일 업로드 권장)</span>
    </div>
    <div v-else class="row" style="align-items:center;">
      <q-spinner-facebook
          color="primary"
          size="2em"
        />
      <span style="margin-left:5px;">Loading...</span>
    </div>
  </q-inner-loading>
  <input ref="input" type="file" accept="image/*" style="position:absolute;left:0px;top:0px;visibility:hidden;" @input="listen__x__oninput" />
</div>
</template>

<script>
import Frame from '@/projects/template_ocr/components/Frame'

import PARSE from '@/js/parse.js'
import MISC from '@/js/miscellaneous.js'

export default {
  props: ['left-mouse-mode', 'template-data', 'draw-label-text', 'draw-predicted-text'],
  components: {
    Frame
  },
  data: function () {
    const Vue = this
    return {
      state: {
        dialogAddField: {
          show: false,
          successCallback: undefined,
          failCallback: undefined
        },
        dialogAddFieldValue: {
          name: '',
          type: Vue.$store.getters.fieldTypes[0],
          language: Vue.$store.getters.fieldLanguages,
          dictionary: {
            name: Vue.$store.getters.fieldDictionaries[0],
            mustPick: false
          },
          writingType: Vue.$store.getters.fieldWritingTypes[0]
        },
        loading: false,
        counterDrag: 0,
        files: []
      },
      frameData: {
        _uid: MISC.getUuid4(),
        _empty: true
      }
    }
  },
  methods: {
    listen__view__onmousedown: function (e, type) {
      this.$refs['frame'].mousedown(e, type);
    },
    listen__view__onwheel: function (e) {
      this.$refs['frame'].listen__view__onwheel(e);
    },
    listen__layer__onclick: function () {
      if (this.state.counterDrag > 0 || this.state.loading == true)
        return;
      if (this.state.files.length > 0)
        return;
      this.$refs['input'].click();
    },
    listen__x__oninput: function () {
      const Vue = this
      const file = Vue.$refs['input'].files[0]
      Vue.onfilechange(file);
    },
    listen__layer__ondragenter: function (e) {
      e.preventDefault()
      this.state.counterDrag++;
    },
    listen__layer__ondragleave: function (e) {
      e.preventDefault()
      this.state.counterDrag--;
    },
    listen__layer__ondragover: function (e) {
      e.preventDefault()
    },
    listen__layer__ondrop: function (e) {
      e.preventDefault()
      this.state.counterDrag = 0
      if (e.dataTransfer.files.length == 1)
        this.onfilechange(e.dataTransfer.files[0]);
      else
        this.$q.notify({
          message: '하나의 파일만 드래그 해 주세요.',
          icon: 'announcement',
          color: 'purple'
        })
    },
    listen__frame__onfieldadd: function (e) {
      const Vue = this;
      this.state.dialogAddField = {
        show: true,
        successCallback: () => {
          if (this.state.dialogAddFieldValue.name.length == 0) {
            Vue.$refs['dialogAddFieldNameField'].validate()
            return
          } else if (Vue.state.dialogAddFieldValue.language.length == 0) {
            this.$q.notify({
              message: '적어도 하나의 인식 언어를 선택해 주세요..',
              icon: 'announcement',
              color: 'purple'
            })
            return
          }
          const ret = e.success({
            name: this.state.dialogAddFieldValue.name,
            drawLabelText: this.drawLabelText,
            drawPredictedText: this.drawPredictedText,
            id: MISC.getUuid4(),
            mode: this.leftMouseMode
          });
          Vue.$emit('onfieldadd', {
            id: ret.id,
            rect: [
              parseInt(ret.handles.start.x),
              parseInt(ret.handles.start.y),
              parseInt(ret.handles.end.x),
              parseInt(ret.handles.end.y)
            ],
            ...JSON.parse(JSON.stringify(this.state.dialogAddFieldValue))
          });
          Vue.$refs['dialogAddField'].hide()
        },
        failCallback: e.fail
      }
    },
    listen__frame__onfieldremove: function (id) {
      this.$emit('onfieldremove', id)
    },
    listen__frame__onfieldmove: function (data) {
      this.$emit('onfieldmove', data)
    },
    listen__daf__clear: function () {
      this.state.dialogAddFieldValue.name =''
    },
    onfilechange: function (file) {
      const Vue = this

      if (Vue.frameData._empty == false) {
        Vue.frameData = {
          id: MISC.getUuid4(),
          _empty: true
        }
      }
      Vue.state.files = []

      if (file == undefined)
        return

      let tokens = file.name.split('.')
      if (tokens.length < 2) {
        Vue.oneerror({message: "JPG / PNG 형식만 지원 됩니다."});
        return
      }
      let ext = tokens[tokens.length - 1].toLowerCase()
      if (ext != "jpg" && ext != "jpeg" && ext != "png") {
        Vue.onerror({message: "JPG / PNG 형식만 지원 됩니다."});
        return
      }
      Vue.loadingLayer(true);
      
      Vue.doubleRaf(async () => {
        let image;
        
        let tokens = file.name.split('.');
        let ext = tokens[tokens.length - 1].toLowerCase();
        try {
          image = await PARSE.parseImage(file, ext);
        } catch (err) {
          console.log(err)
          Vue.$q.notify({
            message: "이미지 읽기에 실패 하였습니다.",
            icon: 'announcement',
            color: 'red'
          })
          Vue.loadingLayer(false);
          return
        }
        let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);

        Vue.frameData = {
          id: MISC.getUuid4(),
          name: file.name,
          cornerstoneImage,
          _empty: false
        };
        Vue.state.files = [file]
        Vue.loadingLayer(false);
      });
    },
    onerror: function (param) {
      const Vue = this;

      Vue.$q.notify({
        message: param.message,
        icon: 'announcement',
        color: 'red'
      })
    },
    doubleRaf: function (callback) {
      requestAnimationFrame(() => {
        requestAnimationFrame(callback)
      })
    },
    loadingLayer(value) {
      this.state.loading = value
    },
    fitToWindow() {
      this.$refs['frame'].fitToWindow()
    },
    zoom(value) {
      this.$refs['frame'].zoom(value)
    },
    getImageSize() {
      if (this.frameData._empty == true) 
        return [0, 0]
      else
        return [this.frameData.cornerstoneImage.width, this.frameData.cornerstoneImage.height]
    },
    move(rect) {
      this.$refs['frame'].move(rect)
    },
    setVisibleAnnotation(ids) {
      this.$refs['frame'].setVisibleAnnotation(ids)
    }
  },
  async mounted () {
    const templateData = this.templateData
    if (templateData != undefined) {
      let cornerstoneImage = await this.$cornerstone.createCornerstoneImageRgba(undefined, templateData.imageData.pixelData, templateData.imageData.width, templateData.imageData.height);
      this.frameData = {
        id: MISC.getUuid4(),
        name: `${templateData.template.templateName}.${templateData.template.sampleFileExtension}`,
        cornerstoneImage,
        _empty: false,
        fields: templateData.template.fields
      };
    }
  }
}
</script>

<style scoped>
.image-view {
  display: block;
  position: relative;
  background-color: #f0f0f0;
  background-image: 
    linear-gradient(45deg,#e0e0e0 25%,transparent 0,transparent 75%,#e0e0e0 0,#e0e0e0),
    linear-gradient(45deg,#e0e0e0 25%,transparent 0,transparent 75%,#e0e0e0 0,#e0e0e0);
  background-size: 40px 40px;
  background-position: 0 0,20px 20px;
  background-position-x: 0px, 20px;
  background-position-y: 0px, 20px;
  overflow: hidden;
}
</style>